import { render } from "./lhc.vue?vue&type=template&id=087a8932&scoped=true"
import script from "./lhc.vue?vue&type=script&lang=js"
export * from "./lhc.vue?vue&type=script&lang=js"

import "./lhc.vue?vue&type=style&index=0&id=087a8932&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-087a8932"]])

export default __exports__